import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { InputField } from "../../FormField";

const Employee = ({ data }) => {
  const employeeName = data["EmployeeName"] || {};
  const identification = data["Identification"] || {};
  const birthDate = data["BirthDate"] || {};
  const gender = data["Gender"] || {};
  const maritalStatus = data["MaritalStatus"] || {};
  const nationality = data["Nationality"] || {};
  const jobTitle = data["JobTitle"] || {};
  const height = data["Height"] || {};
  const weight = data["Weight"] || {};

  return (
    <fieldset>
      <h3>{"EMPLOYEE'S INFORMATION"}</h3>
      <section className="basicinfo">
        <div>
          <label htmlFor="EmployeeName">Name of Employee (as in NRIC)</label>
          <div className="field-container" id="RO_EmployeeName">
            <InputField name="EmployeeName" {...employeeName} />
          </div>
        </div>
        <div style={{ width: 300 }}>
          <label htmlFor="Identification">NRIC/Passport No.</label>
          <div className="field-container" id="RO_Identification">
            <InputField name="Identification" {...identification} />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="BirthDate">Date of Birth</label>
          <div className="field-container" id="RO_BirthDate">
            <InputField
              name="BirthDate"
              format={value => isExist(value) && moment(value).format()}
              {...birthDate}
            />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="Gender">Sex</label>
          <div className="field-container" id="RO_Gender">
            <InputField name="Gender" {...gender} />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="Nationality">Nationality</label>
          <div className="field-container">
            <InputField name="Nationality" {...nationality} />
          </div>
        </div>
        <div style={{ width: 300 }}>
          <label htmlFor="JobTitle">Occupation</label>
          <div className="field-container">
            <InputField name="JobTitle" {...jobTitle} />
          </div>
        </div>
        <div style={{ width: 150 }}>
          <label htmlFor="MaritalStatus">Marital Status</label>
          <div className="field-container" id="RO_MaritalStatus">
            <InputField name="MaritalStatus" {...maritalStatus} />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="Height">Height(m)</label>
          <div className="field-container">
            <InputField name="Height" style={{ width: "70%" }} {...height} />
          </div>
        </div>
        <div style={{ width: 100 }}>
          <label htmlFor="Weight">Weight(kg)</label>
          <div className="field-container">
            <InputField name="Weight" style={{ width: "70%" }} {...weight} />
          </div>
        </div>
      </section>
    </fieldset>
  );
};

Employee.propTypes = {
  data: PropTypes.object,
};

export default Employee;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Employee.js